export enum AlertStatus {
  CLOSED = 'CLOSED',
  NOTIFICATION_SHOW = 'SHOW',
  NOTIFICATION_HIDE = 'HIDE'
}
